import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { BrandLogoLink } from '../components/BrandLogoLink';

export function AboutHyperAppStorePage() {
  return (
    <div className="mx-auto w-full max-w-2xl px-4 pb-8 pt-6 text-th-primary">
      <div className="mb-6 flex items-center justify-between gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-th-secondary transition-colors hover:text-th-primary"
        >
          <ArrowLeft className="h-4 w-4" />
          Home
        </Link>
        <BrandLogoLink className="shrink-0" />
      </div>

      <h1 className="text-xl font-semibold tracking-tight sm:text-2xl">About Hyper App Store</h1>
      <p className="mt-2 text-sm text-th-secondary">Discover and run AI apps in one place.</p>

      <div className="mt-8 space-y-4 text-sm leading-relaxed text-th-secondary">
        <p>
          Hyper App Store is a marketplace for AI-powered apps and tools. Browse agents by category, open
          them in your browser, and manage your library and profile from a single account.
        </p>
        <p>
          Credits and subscriptions power usage across the store; you can see plans and billing in your
          profile when signed in.
        </p>
      </div>
    </div>
  );
}
